import {DetailedHTMLProps, FunctionComponent, HTMLAttributes, MouseEventHandler} from 'react';

export type CardProps = {
    onClick?: MouseEventHandler<HTMLAnchorElement>,
    disabled?: boolean,
    dark?: boolean,
    className?: string
}

const Card: FunctionComponent<CardProps> = (props) => {
    let className = 'dfb-Card';

    className += props.disabled ? ' disabled' : '';
    className += props.onClick ? ' clickable' : '';
    className += props.dark ? ' dfb-Card--dark' : '';
    className += props.className ? ` ${props.className}` : '';

    // hacky workaround for ui-kit -.-
    const aProps: DetailedHTMLProps<HTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement> = {};
    const divProps: DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> = {};

    if (props.disabled) {
        aProps['aria-disabled'] = props.disabled;
        divProps['aria-disabled'] = props.disabled;
    }

    if (!!props.onClick) {
        return (
            <a className={className} onClick={props.onClick} {...aProps} role="button">
                {props.children}
            </a>
        );
    }

    return (
        <div className={className} {...divProps}>
            {props.children}
        </div>
    );
};

export default Card;
